import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../context/AuthContext';
import { loanFlowService } from '../../services/api';
import { Smartphone, CreditCard, FileText } from 'lucide-react';

const YOUNITED_FLOW_LOGO = 'https://customer-assets.emergentagent.com/job_de5fd55a-ccb9-4790-966a-0bfe35cdacca/artifacts/fk9u448b_IMG_0370.jpeg';

const LoanPreparation = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [flowId, setFlowId] = React.useState(null);

  useEffect(() => {
    initializeFlow();
  }, []);

  const initializeFlow = async () => {
    try {
      const flow = await loanFlowService.create({
        clientId: user.id,
        loanApplicationId: 'loan1'
      });
      setFlowId(flow.id);
    } catch (error) {
      console.error('Error initializing flow:', error);
    }
  };

  const handleContinue = async () => {
    if (flowId) {
      await loanFlowService.update(flowId, { currentStep: 'mtrust_intro' });
    }
    navigate('/client/loan-flow/mtrust-intro');
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#E3F2FD' }}>
      {/* Header */}
      <div className="bg-white border-b border-gray-200 py-4 px-8">
        <img src={YOUNITED_FLOW_LOGO} alt="Younited" className="h-10 w-auto object-contain" />
      </div>

      {/* Banner */}
      <div className="bg-gray-800 text-white text-center py-2 text-sm">
        Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Card className="p-8 bg-white shadow-xl">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">
            Pour reprendre votre souscription en toute sérénité, voici ce dont vous aurez besoin :
          </h1>

          <div className="space-y-6 mb-8">
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold" style={{ backgroundColor: '#8B5CF6' }}>
                1
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <FileText className="h-5 w-5" style={{ color: '#8B5CF6' }} />
                  <h3 className="font-bold text-gray-900">Vos identifiants impots.gouv.fr</h3>
                </div>
                <p className="text-sm text-gray-600">
                  Comment créer un compte ou récupérer pour une première connexion automatique de vos documents.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold" style={{ backgroundColor: '#8B5CF6' }}>
                2
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <CreditCard className="h-5 w-5" style={{ color: '#8B5CF6' }} />
                  <h3 className="font-bold text-gray-900">Vos identifiants bancaires</h3>
                </div>
                <p className="text-sm text-gray-600">
                  Tel que vous ou sur l'application mobile de votre banque.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold" style={{ backgroundColor: '#8B5CF6' }}>
                3
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <Smartphone className="h-5 w-5" style={{ color: '#8B5CF6' }} />
                  <h3 className="font-bold text-gray-900">Votre téléphone portable</h3>
                </div>
                <p className="text-sm text-gray-600">
                  Vous recevez un SMS pour votre signature électronique.
                </p>
              </div>
            </div>
          </div>

          <Button
            onClick={handleContinue}
            size="lg"
            className="w-full text-white font-medium py-6 text-base"
            style={{ backgroundColor: '#8B5CF6' }}
          >
            Continuer
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default LoanPreparation;
